// extracted by mini-css-extract-plugin
export default {"orderTotal":"Tup6bMeL8pByMTdO3twt","orderLines":"mPRKUQQ47qt_3Wl80hgZ","orderDetails":"BeyQAm0E5QggSoB_44tD","vat":"vhJfzW9HsKroHn1YRqE7 mPRKUQQ47qt_3Wl80hgZ"};